var map = {
	"./allura_cdc/background.svg": "0e18",
	"./bau/background.svg": "ea1a",
	"./home_design/background.svg": "ef70",
	"./midas_cdc/background.svg": "4e10",
	"./millennium_cdc/background.svg": "0365",
	"./omnilink/background.svg": "b90e",
	"./romanzza/background.svg": "3e0d",
	"./size_multiplo/background.svg": "91d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c1d";